/**
 * Normalize free-text region queries for fuzzy Arabic matching.
 *
 * Atlas uses ICU folding; the in-memory cache fallback must tolerate
 * common spelling variants (ta marbuta vs ha, alef forms, alef maksura).
 */
export const normalizeRegionSearchText = (text: string): string =>
  text
    .trim()
    .normalize('NFKC')
    .replace(/[أإآ]/g, 'ا')
    .replace(/ة/g, 'ه')
    .replace(/ى/g, 'ي')
    .toLowerCase();
